export class Log {
    public static log(m: string) {
        console.log(m)
    }
}